import React from "react";
import PageLayout from '../../Components/PageLayout';

function Other() {
    return (
       <PageLayout title="Other" subtitle="Other overview">
            <div className="container flex col box-container">
                {/* <div className="box">Other</div>
                <div className="box">Other</div>
                <div className="box">Other</div> */}
            </div>
        </PageLayout>
    );
}

export default Other;
